const makeConstant = constant => `geolocation/${constant}`

export const FETCH_GEOLOCATION = makeConstant('FETCH_GEOLOCATION')
export const FETCH_GEOLOCATION_PENDING = makeConstant('FETCH_GEOLOCATION_PENDING')
export const FETCH_GEOLOCATION_SUCCESS = makeConstant('FETCH_GEOLOCATION_SUCCESS')
export const FETCH_GEOLOCATION_FAILURE = makeConstant('FETCH_GEOLOCATION_FAILURE')



// WEBPACK FOOTER //
// ./src/modules/geolocation/constants.js